'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _ = require('../../../../../');

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();
var ORGANISM_NAME = 'interactive-tiles';

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _.Heading,
      {
        level: '2',
        className: ORGANISM_NAME + '__heading'
      },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderFooter = function renderFooter(footer) {
  if (footer) {
    return _react2.default.createElement(
      'p',
      { className: ORGANISM_NAME + '__footer' },
      htmlToReactParser.parse(footer.text)
    );
  }
  return null;
};

var InteractiveTiles = function (_Component) {
  _inherits(InteractiveTiles, _Component);

  function InteractiveTiles(props) {
    _classCallCheck(this, InteractiveTiles);

    var _this = _possibleConstructorReturn(this, (InteractiveTiles.__proto__ || Object.getPrototypeOf(InteractiveTiles)).call(this, props));

    _this.renderHeadline = renderHeadline.bind(_this);
    _this.renderParagraph = renderParagraph.bind(_this);
    _this.renderFooter = renderFooter.bind(_this);
    _this.renderTiles = _this.renderTiles.bind(_this);
    return _this;
  }

  _createClass(InteractiveTiles, [{
    key: 'renderTiles',
    value: function renderTiles(tiles, columns, selectedItemTheme, callback) {
      var config = this.props.config;


      if (tiles.length) {
        var markup = [];
        var bootstrapClass = void 0;

        switch (columns) {
          case 2:
            {
              bootstrapClass = 'col-xs-12 col-md-6';break;
            }
          case 3:
            {
              bootstrapClass = 'col-xs-12 col-md-6 col-lg-4';break;
            }
          case 4:
            {
              bootstrapClass = 'col-xs-12 col-md-6 col-lg-3';break;
            }
          default:
        }

        for (var idx = 0; idx < tiles.length; idx += 1) {
          markup.push(_react2.default.createElement(
            'div',
            { key: config.id + '-' + idx, className: bootstrapClass },
            _react2.default.createElement(_.Tile, _extends({}, tiles[idx], {
              theme: selectedItemTheme,
              callback: callback,
              index: idx,
              id: config.id
            }))
          ));
        }
        return markup;
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className,
          callback = _props.callback;
      var id = config.id,
          columns = config.columns,
          downArrow = config.downArrow;
      var theme = config.theme,
          selectedItemTheme = config.selectedItemTheme;

      theme = theme || 'theme-background-color-green';
      selectedItemTheme = selectedItemTheme || 'theme-background-color-blue-alt';

      var sectionClasses = (0, _classnames2.default)(ORGANISM_NAME + '-organism', 'center-block text-xs-center', theme, className);
      var headline = content.headline,
          paragraph = content.paragraph,
          tiles = content.tiles,
          footer = content.footer;


      return _react2.default.createElement(
        'section',
        {
          id: id,
          ref: function ref(c) {
            _this2.organismRef = c;
          },
          className: sectionClasses,
          'data-building-block': 'organism'
        },
        downArrow && _react2.default.createElement('img', {
          alt: 'Down',
          className: ORGANISM_NAME + '__down-arrow',
          src: downArrow.src
        }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderHeadline(headline),
            this.renderParagraph(paragraph)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderTiles(tiles, columns, selectedItemTheme, callback)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            this.renderFooter(footer)
          )
        )
      );
    }
  }]);

  return InteractiveTiles;
}(_react.Component);

exports.default = InteractiveTiles;


InteractiveTiles.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue-alt', 'theme-background-color-green', 'theme-background-color-purple', 'theme-background-color-pink']),
    columns: _propTypes2.default.oneOf([2, 3, 4]).isRequired,
    selectedItemTheme: _propTypes2.default.oneOf(['theme-background-color-blue-alt', 'theme-background-color-green', 'theme-background-color-purple', 'theme-background-color-pink']),
    downArrow: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired
    })
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string
    }),
    tiles: _propTypes2.default.arrayOf(_.Tile.propTypes.content),
    footer: _propTypes2.default.shape({
      text: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string,
  callback: _propTypes2.default.func
};

InteractiveTiles.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/interactive-tiles/main/jsx/InteractiveTiles.js
// module id = 686
// module chunks = 4